import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { useSubscribeOnMount } from '~/hooks/useSubscribeOnMount';
import { Observable } from '~/infra/Observable/Observable';
const ConnectivitySignalsContext = /*#__PURE__*/ createContext(new Observable());
export const useConnectivitySignals = ()=>useContext(ConnectivitySignalsContext);
export function useSubscribeToConnectivitySignals(callback) {
    const signals = useConnectivitySignals();
    useSubscribeOnMount({
        subscribe: (observer)=>signals.subscribe(observer),
        unsubscribe: (id)=>signals.unsubscribe(id)
    }, callback);
}
export const ConnectivitySignalsProvider = (param)=>{
    let { signals, children } = param;
    return /*#__PURE__*/ _jsx(ConnectivitySignalsContext.Provider, {
        value: signals,
        children: children
    });
};
